/**
 * Utility functions for handling referral URLs and codes
 */

/**
 * Generate a referral URL from a referral code
 * @param referralCode The referral code to include in the URL
 * @param baseUrl Optional base URL, defaults to current origin
 * @returns The complete referral URL
 */
export const generateReferralUrl = (referralCode: string, baseUrl?: string): string => {
  const base = baseUrl || window.location.origin;
  return `${base}?ref=${referralCode}`;
};

/**
 * Extract referral code from URL parameters
 * @param searchParams Optional URLSearchParams, defaults to current location
 * @returns The referral code if found, undefined otherwise
 */
export const getReferralCodeFromUrl = (searchParams?: URLSearchParams): string | undefined => {
  const params = searchParams || new URLSearchParams(window.location.search);
  const refCode = params.get('ref');
  return refCode || undefined;
};

/**
 * Check if current URL has a referral code
 * @returns Boolean indicating if referral code exists
 */
export const hasReferralCode = (): boolean => {
  return !!getReferralCodeFromUrl();
};

/**
 * Build a shareable message for referral
 * @param hasReferralCode Whether the user has a referral code
 * @returns The share message text
 */
export const getReferralShareMessage = (hasReferralCode: boolean): string => {
  if (hasReferralCode) {
    return "I just joined the Wabisabi waitlist! Use my referral link to join, and we'll both move up the queue and earn €20 reward";
  }
  return "I just joined the Wabisabi waitlist - a tool that helps you remember what matters most in your relationships. Join me!";
};